var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3285_3683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3285_3683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 16.1849V10.4766L4.16667 7.58073V13.2891L9.16667 16.1849ZM10.8333 16.1849L15.8333 13.2891V7.58073L10.8333 10.4766V16.1849ZM9.16667 18.1016L3.33333 14.7474C3.06944 14.5946 2.86458 14.3932 2.71875 14.1432C2.57292 13.8932 2.5 13.6155 2.5 13.3099V6.6849C2.5 6.37934 2.57292 6.10156 2.71875 5.85156C2.86458 5.60156 3.06944 5.40017 3.33333 5.2474L9.16667 1.89323C9.43056 1.74045 9.70833 1.66406 10 1.66406C10.2917 1.66406 10.5694 1.74045 10.8333 1.89323L16.6667 5.2474C16.9306 5.40017 17.1354 5.60156 17.2813 5.85156C17.4271 6.10156 17.5 6.37934 17.5 6.6849V13.3099C17.5 13.6155 17.4271 13.8932 17.2813 14.1432C17.1354 14.3932 16.9306 14.5946 16.6667 14.7474L10.8333 18.1016C10.5694 18.2543 10.2917 18.3307 10 18.3307C9.70833 18.3307 9.43056 18.2543 9.16667 18.1016ZM13.3333 7.10156L14.9375 6.1849L10 3.33073L8.375 4.26823L13.3333 7.10156ZM10 9.03906L11.625 8.10156L6.6875 5.2474L5.0625 6.1849L10 9.03906Z",
    fill: "#F5D447"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.ca21889b6dacef80bfec9827383b6e6c.svg";
export { ForwardRef as ReactComponent };